module.exports = __webpack_public_path__ + "img/banner1.41b684fe.png";